// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let FeaturesV3 = require("../../reason/featureFlipper/FeaturesV3.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let SubuserMemberListItem = require("./SubuserMemberListItem.bs.js");
let SubuserMemberTableRow = require("./SubuserMemberTableRow.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let SubuserPendingInvitations = require("./SubuserPendingInvitations.bs.js");
let SubusersPageAccountsList_account_graphql = require("../../__generated__/SubusersPageAccountsList_account_graphql.bs.js");

let getConnectionNodes = SubusersPageAccountsList_account_graphql.Utils.getConnectionNodes;

let convertFragment = SubusersPageAccountsList_account_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, SubusersPageAccountsList_account_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(SubusersPageAccountsList_account_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, SubusersPageAccountsList_account_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(SubusersPageAccountsList_account_graphql.node, convertFragment, fRef);
}

let AccountFragment = {
  getConnectionNodes: getConnectionNodes,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function SubusersPageAccountsList(props) {
  let currentUserRole = props.currentUserRole;
  let account = RescriptRelay_Fragment.useFragment(SubusersPageAccountsList_account_graphql.node, convertFragment, props.account);
  let members = getConnectionNodes(account.members);
  if (FeaturesV3.useIsSubuserInvitationsEnabled() === true) {
    return JsxRuntime.jsxs("table", {
      children: [
        JsxRuntime.jsx("thead", {
          children: JsxRuntime.jsxs("tr", {
            children: [
              JsxRuntime.jsx("th", {
                children: "Name",
                className: "w-[24%] py-3 pr-4 font-medium"
              }),
              JsxRuntime.jsx("th", {
                children: "Email",
                className: "w-[29%] py-3 pr-4 font-medium"
              }),
              JsxRuntime.jsx("th", {
                children: "Role",
                className: "w-[19%] py-3 pr-4 font-medium"
              }),
              JsxRuntime.jsx("th", {
                children: "Status",
                className: "w-[13%] py-3 pr-4 font-medium"
              }),
              JsxRuntime.jsx("th", {
                children: "Actions",
                className: "w-[15%] py-3 text-right font-medium"
              })
            ],
            className: "border-b border-zinc-200 text-left text-sm text-zinc-500"
          }),
          className: "hidden md:table-header-group"
        }),
        JsxRuntime.jsxs("tbody", {
          children: [
            members.map(member => JsxRuntime.jsx(SubuserMemberTableRow.make, {
              member: member.fragmentRefs,
              account: account.fragmentRefs,
              currentUserRole: currentUserRole
            }, member.id)),
            JsxRuntime.jsx(SubuserPendingInvitations.make, {
              account: account.fragmentRefs,
              currentUserRole: currentUserRole
            })
          ],
          className: "divide-y divide-zinc-200"
        })
      ],
      "aria-label": "Account users",
      className: "w-full table-fixed"
    });
  } else {
    return JsxRuntime.jsx("div", {
      children: members.map((member, index) => JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(SubuserMemberListItem.make, {
          member: member.fragmentRefs,
          account: account.fragmentRefs,
          currentUserRole: currentUserRole
        })
      }, index.toString()))
    });
  }
}

let make = SubusersPageAccountsList;

exports.AccountFragment = AccountFragment;
exports.make = make;
/* FeaturesV3 Not a pure module */
